export default "__VITE_ASSET__DbCe45i7__"